/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkHours } from './workHours';


export interface Availability { 
    mon: Array<WorkHours>;
    tue: Array<WorkHours>;
    wed: Array<WorkHours>;
    thu: Array<WorkHours>;
    fri: Array<WorkHours>;
    sat: Array<WorkHours>;
    sun: Array<WorkHours>;
}

